<template>
	<div>
		<div class="row">
			<div class="col-lg-12 mb-3">
				<b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
				<b-card :header="$t('general.isometric_management.revision.title')" header-tag="h3" class="bg-default-card">
					<revision-control-table
						ref="rt"
						requestButton
						partsButton
						@pressEdit="onEditRow"
						@pressDelete="onDeleteRow"
						@pressAdd="onAddRow"
						@pressRequest="onRequests"
						@pressParts="pressParts"
						@pressReturn="onReturn"
                        actionWidth="130px"
                    >
						<span slot="return">
							{{$t('general.buttons.return_to.return_to_isometric_management')}}
						</span>
						<span slot="add" >
							{{ $t('general.isometric_management.revision.create_button') }}
						</span>
					</revision-control-table>
				</b-card>
			</div>
		</div>

        <revision-control-modal :model.sync="this.model" :title="actionTitle" ref="addModal" settingType="reason_for_revision" @ok="saveAction"/>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="editModal" id="editModal" :title="actionTitle" size="lg" @ok="saveAction" :body-class="'pb-0'" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_revisions'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedLine"
                                :options="currentLine"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isLineLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="line_number" track-by="id"
                                :selectLabel="''"
                                @search-change="onLineSearch"
                                @input="updateLine"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedLine != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedLine"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.area') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.area">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.field_area') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.field_area">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.iso_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.iso_no"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.page_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.page_no"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_class') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.line_class">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pipe_material') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.pipe_material">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.tie_in_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.tie_in_no">
                        </div>
                    </div>

                    <div class="row mb-3" style="z-index: 0;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.shut_down_iso') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <toggle-button v-model="model.shut_down_iso" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.test_circuit_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.test_circuit_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_size') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.line_size">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.work_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedWorkType"
                                :options="currentWorkType"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isWorkTypeLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="value" track-by="id"
                                :selectLabel="''"
                                @search-change="onWorkTypeSearch"
                                @input="updateWorkType"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedWorkType != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWorkType"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.fluid') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.fluid">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.process_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.process_code">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.location_from') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.location_from">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.location_to') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.location_to">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.operating_press') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.operating_press">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.operating_temp') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.operating_temp">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.design_press') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.design_press">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.design_temp') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.design_temp">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_press') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.testing_press">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_med') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.testing_med">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.p_and_id_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.p_and_id_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remark') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remark"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.priority') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.priority">
                                <option v-for="priority in drawing_priority" :value="priority.name" :key="priority.name">{{priority.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row">
                        <div class="col-lg-4">
                            <label>{{ $t('table.delayed') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <toggle-button v-model="model.delayed" :sync="true" :value="false" :color="{checked: '#ff471a'}" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ndt') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <toggle-button v-model="model.ndt" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_rt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.nde_extent_rt">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_pt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.nde_extent_pt">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_mt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.nde_extent_mt">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_ut') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.nde_extent_ut">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_others') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.nde_extent_others">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.authorization_authority') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0;">
                            <toggle-button v-model="model.authorization_authority" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>
                    
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ped_category') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.ped_category">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ped_module_or_hazard') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.ped_module_or_hazard">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.special_work') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="model.special_work">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.heat_tracing') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.heat_tracing">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.insulation_or_tracing_type">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.insulation_or_tracing_thickness">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.painting_code">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.painting_thickness">
                        </div>
                    </div>

                    <div class="row mb-3" style="z-index: 0;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.progress_status') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <input disabled type="text" class="form-control" v-model="model.work_history_progress_status">
                        </div>
                    </div>

                    <div class="row mb-3" style="z-index: 0;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.current_team') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <input disabled type="text" class="form-control" v-model="model.work_history_team">
                        </div>
                    </div>

                    <div class="row mb-3" style="z-index: 0;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.current_team_member') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <input disabled type="text" class="form-control" v-model="model.work_history_team_member">
                        </div>
                    </div>

                    <div class="row mb-3" style="z-index: 0;">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pwht') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <toggle-button disabled v-model="model.line.pwht" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.visual_test') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.line.visual_test" disabled>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.supports') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.supports">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.start_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.start_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.end_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.end_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row">
                        <div class="col-lg-4">
                            <label>{{ $t('table.spool_amount') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="model.spool_amount" disabled>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.cleaning') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.line.cleaning">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.note_1') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea disabled rows="4" class="form-control" v-model="model.line.note_1"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.note_2') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea disabled rows="4" class="form-control" v-model="model.line.note_2"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.revision_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" disabled class="form-control" v-model="model.revision_number">
                        </div>
                    </div>
                    
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_description"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_reason') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.revision_reason_setting"
								:options="currentReason"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isReasonLoading"
								:preserve-search="true"
								placeholder=""
								label="value" track-by="id"
								:selectLabel="''"
								@search-change="onReasonSearch"
							>
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.revision_reason_setting != null && typeof model.revision_reason_setting.id != 'undefined' && model.revision_reason_setting.id != null"  
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedProjectSetting"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_remarks"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-2" v-if="getData.getFiles.length > 0 && $store.getters.hasPermission(['files'], ['read'])">
                <div class="col-lg-12">
                     <label>{{ $t('table.uploaded_files') }}</label>
                </div>
                <div class="col-lg-6" v-for="file in getData.getFiles" :key="file.id">
                    <div class="card p-2">
                        <div style="width: 100%; display: block">
                            <p v-if="$store.getters.hasPermission(['files'], ['delete'])" class="float-left customLink" @click="onDownloadFile(file.id)" :title="file.file_name">{{file.file_name}}</p>
                            <p class="float-right p-0 m-0"><i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteFile(file.id)"></i></p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div v-if="row != null">
                <div v-if="hasWorkHistoryPermission">
                    <hr>
                    <h3>{{ $t('general.isometric_management.working_history_title') }}</h3>
                    <data-table
                        :exportable="false"
                        title=""
                        :search="false"
                        :rows="getData.workHistoryData"
                        :columns="historyColumnData"
                        @rowClickEdit="onEditWorkingRow"
                        @rowClickDelete="onDeleteWorkingRow"
                        @rowClickTask="onTaskWorkingRow"
                        :paginate="false"
                    >
                    </data-table>
                    <i class="btn pull-right mt-2 fa fa-2x fa-plus-square" :title="$t('general.buttons.add_work_history')" style="padding: 0 0 5px 0;" @click="onAddWorkingHistory" v-if="this.$store.getters.hasPermission(['project_work_history'], ['create'])"></i>
                    <div class="clearfix"></div>
                </div>

                <div v-if="hasSpoolPermission">
                    <hr>
                    <h3>{{ $t('general.construction.spool_management.title_modal') }}</h3>
                    <data-table
                        :exportable="false"
                        title=""
                        :search="false"
                        :rows="getData.spoolData"
                        :columns="spoolColumnData"
                        @rowClickDelete="onDeleteSpoolRow"
                        @rowClickEdit="onEditSpoolRow"
                        :paginate="false"
                    >
                    </data-table>
                    <i class="btn pull-right mt-2 fa fa-2x fa-plus-square" :title="$t('general.buttons.add_spool')" style="padding: 0 0 5px 0;" @click="onAddSpool" v-if="this.$store.getters.hasPermission(['project_spool_management'], ['create'])"></i>
                </div>
            </div>
        </b-modal>

        <working-history-modal 
            ref="historyModal" 
            table="drawing" 
            :title="actionTitle" 
            :model.sync="working_model" 
            @onLoadTable="onLoadWorkHistoryTable"
            @onLoadTableMain="refreshIsoTable"
        />

        <task-modal 
            ref="taskModal"
            :title="actionTitleTask" 
            :tableNameTranslated="tableNameTranslated" 
            :specialInputs.sync="specialInputs" 
            :model.sync="task_model" 
        />

        <spool-modal 
            ref="spoolModal" 
            :title="actionTitle" 
            :model.sync="spool_model" 
            @onLoadSpoolsTable="onLoadSpoolsTable"
        />

        <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
            {{ delete_message }}
        </confirm-dialog>

        <confirm-dialog ref="deleteModalWorking" :title="actionTitleDelete" @buttonClick="deleteActionWorking">
            {{ delete_message }}
        </confirm-dialog>

        <confirm-dialog ref="deleteModalSpool" :title="actionTitleDelete" @buttonClick="deleteActionSpool">
            {{ delete_message }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import miniToastr from 'mini-toastr';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Multiselect from 'vue-multiselect';
import WorkingHistoryModal from '@/components/global/modals/WorkingHistoryModal.vue';
import SpoolModal from '@/components/global/modals/SpoolModal.vue';
import TaskModal from '@/components/global/modals/TaskModal.vue';
import RevisionControlModal from '@/components/global/modals/RevisionControlModal.vue';
import RevisionControlTable from '@/components/global/tables/RevisionControlTable.vue';

export default {
    name: 'isometricmanagement',
    components: {
        DataTable,
        ConfirmDialog,
        Multiselect,
        flatPickr,
        WorkingHistoryModal,
        SpoolModal,
        TaskModal,
        RevisionControlModal,
		RevisionControlTable,
    },
    data() {
        return {
            breadcrumbItems: [
				{
					text: Vue.i18n.translate('general.dashboard.title'),
					to: '/'
				},
				{
					text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
					to: '/project/'+this.$route.params.id,
				},
				{
					text: Vue.i18n.translate('general.isometric_management.title'),
					active: true
				},
				{
					text: Vue.i18n.translate('general.revision.title'),
					active: true
				}
			],

            tableName: 'drawing',
            tableNameTranslated: Vue.i18n.translate('general.revision.main_title'),

            row: null,
            rowHistory: null,
            rowSpool: null,

            hasWorkHistoryPermission: false,
            hasSpoolPermission: false,

            searchInput: '',
            actionTitle: '',
            actionTitleTask: '',
            actionTitleDelete: '',
            
            file_id: null,
            isFileDelete: false,
            delete_message: '',
            specialInputs: [],

            selectedLine: null,
            currentLine: [],
            isLineLoading: false,

            selectedWorkType: null,
            currentWorkType: [],
            isWorkTypeLoading: false,

			currentReason: [],
            isReasonLoading: false,

            getData: {
                rowData: [],
                getTeams: [],
                getFiles: [],
                workHistoryData: [],
                spoolData: [],
            },
            model: {
                revision_number: null,
                iso_no: null,
                line_id: null,
                project_id: null,
                discipline_id: null,
                page_no: null,
                start_date: null,
                end_date: null,
                priority: null,
                delayed: null,
                shut_down_iso: null,
                field_area: null,
                work_type_id: null,
                ndt: null,
                file: null,
                remark: null,
                authorization_authority: null,
                special_work: null,
                heat_tracing: null,
                supports: null,
                rt_bw_total: null,
                spool_amount: null,
                line: {
                    area: null,
                    serial_no: null,
                    line_class: null,
                    pipe_material: null,
                    tie_in_no: null,
                    test_circuit_no: null,
                    line_size: null,
                    fluid: null,
                    process_code: null,
                    location_from: null,
                    location_to: null,
                    operating_press: null,
                    operating_temp: null,
                    design_press: null,
                    design_temp: null,
                    testing_press: null,
                    testing_med: null,
                    p_and_id_no: null,
                    nde_extent_rt: null,
                    nde_extent_pt: null,
                    nde_extent_mt: null,
                    nde_extent_ut: null,
                    nde_extent_others: null,
                    ped_category: null,
                    ped_module_or_hazard: null,
                    insulation_or_tracing_type: null,
                    insulation_or_tracing_thickness: null,
                    painting_code: null,
                    painting_thickness: null,
                    working_group_name: null,
                    work_history_team: null,
                    work_history_team_member: null,
                    pwht: null,
                    visual_test: null,
                    cleaning: null,
                    note_1: null,
                    note_2: null,
                },
                revision_number: null,
				revision_date: null,
				revision_description: null,
				revision_reason: null,
				revision_reason_setting: null,
				revision_remarks: null,
            },
            working_model: {
                id: null,
                team_id: null,
                user_id: null,
                date: null,
                remark: null,
                team: null,
                user: null,
                project_setting: null,
            },
            spool_model: {
                id: null,
                line: { 'line_number': '' },
                work_history_progress_status: null,
                iso_no: null,
                line_id: null,
                user_store_id: null,
                user_pickup_id: null,
                team_pickup_id: null,
                team_store_id: null,
                ndt_test: null,
                heat_treatment: null,
                picked_up_date: null,
                storage_date: null,
                spool_no: null,
                prefab_visual_test: null,
                prefab_checked: null,
                prefab_ndt_finished: null,
                prefab_pwht_finished: null,
                ready_erection: null,
                erection_visual_test: null,
                erection_checked: null,
                erection_ndt_finished: null,
                erection_pwht_finished: null,
                ready_pressure_test: null,
                partial_pressure_test: null,
                painting_finished: null,
                insulation_finished: null,
                remark1: null,
                remark2: null,
                remark3: null,
                storage_place: null,
                x_axis: null,
                y_axis: null,
                material_picked_up: null,
                painting_done: null,
                prefab_started: null,
                prefab_finished: null,
                spool_picked_up: null,
                erection_started: null,
                welding_finished: null,
                supports_installed: null,
                pressure_test_finished: null,
                reinstallment_done: null,
                delayed: null,
                selectedTeamStored: null,
                selectedTeamPickedUp: null,
                selectedUserStore: null,
                selectedUserPickup: null,
                selectedProgress: null,
                selectedStorage: null,
            },
            task_model: {
                id: null,
                loggedUser: null,
                task_no: null,
                task_title: null,
                by_user_id: null,
                to_company_id: null,
                to_user_id: null,
                to_team_id: null,
                discipline_id: null,
                latest_date: null,
                exact_date: null,
                exact_time: null,
                importancy: null,
                urgency: null,
                status: null,
                closed: null,
                selectedToCompany: null,
                selectedUser: null,
                selectedToTeam: null,
            },
            historyColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '120px',
                    showEditButton: true,
                }, 
                {
                    label: Vue.i18n.translate('table.working_group'),
                    field: 'team.name',
                    numeric: false,
                    html: false,
                }, 
                {
                    label: Vue.i18n.translate('table.date'),
                    width: '90x',
                    field: 'date',
                    numeric: false,
                    html: false,
                }, 
                {
                    label: Vue.i18n.translate('table.progress_status'),
                    field: 'project_setting.info',
                    numeric: false,
                    html: false,
                }, 
                {
                    label: Vue.i18n.translate('table.remark'),
                    field: 'remark',
                    numeric: false,
                    html: false,
                }
            ],
            spoolColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    showEditButton: true,
                },
                {
                    label: Vue.i18n.translate('table.spool_no'),
                    field: 'spool_no',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted() {
        this.hasWorkHistoryPermission = this.$store.getters.hasPermission(['project_work_history'], ['read']);
        this.hasSpoolPermission       = this.$store.getters.hasPermission(['project_spool_management'], ['read']);

        this.$refs.rt.load('drawing?filters[parent_drawing_id]='+ this.$route.params.id2);
    },
    computed: {
        drawing_priority: {
            get () {
                let drawing_priority = this.$store.getters.getDrawingPriority;
                return drawing_priority;
            }
        },
        default_disciplines: {
            get: function () {
                return this.$store.getters.getDefaultDisciplines;
            }
        }
    },
    watch: {
        drawing_priority: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        default_disciplines: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        saveAction (e) {
            e.preventDefault();

            if (this.model.revision_reason_setting == null) {
				this.model.revision_reason_setting = { 'id': null }
			}

            let data = {
                iso_no:                  this.model.iso_no,
                line_id:                 this.model.line_id,
                project_id:              this.$route.params.id,
                discipline_id:           1,
                page:                    this.model.page_no,
                start_date:              this.model.start_date,
                end_date:                this.model.end_date,
                priority:                this.model.priority,
                shut_down_iso:           this.model.shut_down_iso,
                field_area:              this.model.field_area,
                work_type_id:            this.model.work_type_id,
                ndt:                     this.model.ndt,
                remark:                  this.model.remark,
                authorization_authority: this.model.authorization_authority,
                special_work:            this.model.special_work,
                heat_tracing:            this.model.heat_tracing,
                supports:                this.model.supports,
                rt_bw_total:             this.model.rt_bw_total,
                pt:                      this.model.pt,
                ut:                      this.model.ut,
                mt:                      this.model.mt,

                revision_number:         this.model.revision_number,
                revision_remarks:        this.model.revision_remarks,
                revision_reason:         this.model.revision_reason_setting.id,
                revision_description:    this.model.revision_description,
                revision_date:           this.model.revision_date,
                id:                      this.model.id,
                project_id:              this.$route.params.id,
                from_revision_control: 1,
            }

            Object.keys(data).forEach(key => {
                if (data[key] === '') {
                    data[key] = null;
                }
            });

            if (this.row) {
                data['date'] = data.date ? data.date : null;
                data['id'] = this.$route.params.id2;
                http.route(this.tableName + '/' + this.row.id).patch(data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.$refs.rt.refresh();

                        this.$refs.editModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                http.route('drawing/'+this.$route.params.id2).get().then(response => {
                    if (!response.isError) {
                        data['id'] = this.$route.params.id2;
                        data['line_id'] = response.data.line_id;

                        http.route(this.tableName).post(data, true).then(response => {
                            if (!response.isError) {
                                let id = response.data.id;

                                this.$refs.rt.refresh();
                                this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                                this.$refs.addModal.hide();
                            } else {
                                Object.keys(response.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                                });
                            }
                        });
                    }
                });
            }
        },
        findLastRevisionNumber(request) {
			return new Promise(resolve => {
				http.route(request).get().then(response => {
                    if (!response.isError) {
					    this.model.revision_number = response.data+1;
                    } else {
					    this.model.revision_number = null;
					}
					resolve(this.model.revision_number);
				});
			});
		},
        async onAddRow() {
			this.actionTitle = Vue.i18n.translate('general.revision.create_button');
			this.row = null;

			this.model.revision_number = null;
			this.model.revision_remarks = null;
			this.model.revision_reason = null;
			this.model.revision_reason_setting = null;
			this.model.revision_description = null;
			this.model.revision_date = null;

            this.model.work_history_progress_status = null;
            this.model.work_history_team = null;
            this.model.work_history_team_member = null;

			this.model.iso_no = null;
            this.model.line_id = null;
            this.model.working_group_id = null;
            this.model.user_id = null;
            this.model.discipline_id = null;
            this.model.page_no = null;
            this.model.start_date = null;
            this.model.end_date = null;
            this.model.priority = null;
            this.model.shut_down_iso = null;
            this.model.field_area = null;
            this.model.work_type_id = null;
            this.model.ndt = null;
            this.model.remark = null;
            this.model.authorization_authority = null;
            this.model.special_work = null;
            this.model.heat_tracing = null;
            this.model.supports = null;
            this.model.line.area = null;
            this.model.line.serial_no = null;
            this.model.line.line_class = null;
            this.model.line.pipe_material = null;
            this.model.line.tie_in_no = null;
            this.model.line.test_circuit_no = null;
            this.model.line.line_size = null;
            this.model.line.fluid = null;
            this.model.line.process_code = null;
            this.model.line.location_from = null;
            this.model.line.location_to = null;
            this.model.line.operating_press = null;
            this.model.line.operating_temp = null;
            this.model.line.design_press = null;
            this.model.line.design_temp = null;
            this.model.line.testing_press = null;
            this.model.line.testing_med = null;
            this.model.line.p_and_id_no = null;
            this.model.line.nde_extent_rt = null;
            this.model.line.nde_extent_pt = null;
            this.model.line.nde_extent_mt = null;
            this.model.line.nde_extent_ut = null;
            this.model.line.nde_extent_others = null;
            this.model.line.ped_category = null;
            this.model.line.ped_module_or_hazard = null;
            this.model.line.insulation_or_tracing_type = null;
            this.model.line.insulation_or_tracing_thickness = null;
            this.model.line.painting_code = null;
            this.model.line.painting_thickness = null;
            this.model.line.working_group_name = null;
            this.model.line.pwht = null;
            this.model.line.cleaning = null;
            this.model.line.note_1 = null;
            this.model.line.note_2 = null;

			this.model.revision_number = await this.findLastRevisionNumber('drawing/'+this.$route.params.id2+'/maxrevision?project_id='+this.$route.params.id);
			this.$refs.addModal.show();
		},
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.model.revision_number = this.row.revision_number;
            this.model.iso_no = this.row.iso_no;
            this.model.line_id = this.row.line_id;
            this.model.project_id = this.row.project_id;
            this.model.discipline_id = this.row.discipline_id;
            this.model.page_no = this.row.page;
            this.model.start_date = this.row.start_date;
            this.model.end_date = this.row.end_date;
            this.model.priority = this.row.priority;
            this.model.delayed = Boolean(this.row.delayed);
            this.model.shut_down_iso = Boolean(this.row.shut_down_iso);
            this.model.field_area = this.row.field_area;
            this.model.work_type_id = this.row.work_type_id;
            this.model.ndt = Boolean(this.row.ndt);
            this.model.remark = this.row.remark;
            this.model.authorization_authority = Boolean(this.row.authorization_authority);
            this.model.special_work = this.row.special_work;
            this.model.heat_tracing = this.row.heat_tracing;
            this.model.supports = this.row.supports;
            this.model.spool_amount = this.row.spool_amount;
            this.selectedLine = this.row.line;
            this.model.line.line_id = this.row.line.id;
            this.model.line.area = this.row.line.area;
            this.model.line.serial_no = this.row.line.serial_no;
            this.model.line.line_class=this.row.line.line_class;
            this.model.line.pipe_material = this.row.line.pipe_material;
            this.model.line.tie_in_no = this.row.line.tie_in_no;
            this.model.line.test_circuit_no = this.row.line.test_circuit_no;
            this.model.line.line_size = this.row.line.line_size;
            this.model.line.fluid = this.row.line.fluid;
            this.model.line.process_code = this.row.line.process_code;
            this.model.line.location_from = this.row.line.location_from;
            this.model.line.location_to = this.row.line.location_to;
            this.model.line.operating_press = this.row.line.operating_press;
            this.model.line.operating_temp = this.row.line.operating_temp;
            this.model.line.design_press = this.row.line.design_press;
            this.model.line.design_temp = this.row.line.design_temp;
            this.model.line.testing_press = this.row.line.testing_press;
            this.model.line.testing_med = this.row.line.testing_med;
            this.model.line.p_and_id_no = this.row.line.p_and_id_no;
            this.model.line.nde_extent_rt = this.row.line.nde_extent_rt;
            this.model.line.nde_extent_pt = this.row.line.nde_extent_pt;
            this.model.line.nde_extent_mt = this.row.line.nde_extent_mt;
            this.model.line.nde_extent_ut = this.row.line.nde_extent_ut;
            this.model.line.nde_extent_others = this.row.line.nde_extent_others;
            this.model.line.ped_category = this.row.line.ped_category;
            this.model.line.ped_module_or_hazard = this.row.line.ped_module_or_hazard;
            this.model.line.insulation_or_tracing_type = this.row.line.insulation_or_tracing_type;
            this.model.line.insulation_or_tracing_thickness = this.row.line.insulation_or_tracing_thickness;
            this.model.line.painting_code = this.row.line.painting_code;
            this.model.line.painting_thickness = this.row.line.painting_thickness;
            this.model.line.working_group_name = this.row.line.working_group_name;
            this.model.line.cleaning = this.row.line.cleaning;
            this.model.line.note_1 = this.row.line.note_1;
            this.model.line.note_2 = this.row.line.note_2;
            this.model.line.pwht = Boolean(this.row.line.pwht);
            this.model.line.visual_test = this.row.line.visual_test;
            this.model.rt_bw_total = this.row.rt_bw_total;
            this.model.work_history_team = this.row.work_history_team;
            this.model.work_history_team_member = this.row.work_history_team_member;
            this.model.work_history_progress_status = this.row.work_history_progress_status;
            this.model.pt = this.row.pt;
            this.model.ut = this.row.ut;
            this.model.mt = this.row.mt;

            this.model.revision_number = row.revision_number;
			this.model.revision_remarks = row.revision_remarks;
			this.model.revision_reason = row.revision_reason;
			this.model.revision_description = row.revision_description;
			this.model.revision_reason_setting = row.revision_reason_setting;
			this.model.revision_date = row.revision_date;

            this.selectedWorkType = this.row.work_type;
            this.spool_model.line = this.row.line;
            this.spool_model.iso_no = this.row.iso_no;
            this.onViewFiles(row.id);

            this.getData.workHistoryData = [];
            if (this.hasWorkHistoryPermission) {
                this.onLoadWorkHistoryTable();
            }

            this.getData.spoolData = [];
            if (this.hasSpoolPermission) {
                this.onLoadSpoolsTable();
            }

            this.$refs.editModal.show();
        },
        onDeleteRow (row) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.delete_message = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.file_id = null;
            this.isFileDelete = false;
            this.$refs.deleteModal.show();
        },
        onDeleteFile (id) {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.delete_message = Vue.i18n.translate('messages.delete_file');
            this.file_id = id;
            this.isFileDelete = true;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                if (this.isFileDelete == true) {
                    let data = http.route('file/' + this.file_id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            this.$refs.rt.refresh();
                            this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                            this.file_id = null;
                            this.$refs.editModal.hide();
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                } else if (this.isFileDelete == false) {
                    let data = http.route(this.tableName + '/' + this.row.id).delete();
                    data.then(response => {
                        if(!response.isError) {
                            this.$refs.rt.refresh();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                }
            }
            this.$refs.deleteModal.hide();
        },
        onViewFiles (id) {
            this.getData.getFiles.length = 0;
            let data = http.route('file?get_all=1&filters[drawing_id]=' + id).get();
            data.then(response => {
                if(response.data == false) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.getData.getFiles = response.data;
                }
            });
        },
        onDownloadFile (id) {
            let data = http.route('file/' + id).get(
            {
                export_pdf: 1
            }, true);
            data.then(response => {
                if (!response.isError) {
                    this.successMsg(Vue.i18n.translate('messages.file.file_download'));
                    let data = http.route('get_content/file/'+response.data.id+'/'+response.data.file_name).downloadPdf({}, response.data.file_name).then(res => {});
                } else {
                    this.errorMsg(Vue.i18n.translate('messages.file.error_download'));
                }
            });
        },
        pressParts (row) {
			this.$router.push({name: 'isometric_management_parts', params: {id:this.$route.params.id, id2:row.id}});
		},
		onReturn() {
			this.$router.push({name: 'isometric_management', params: {id:this.$route.params.id}});
		},
        onRequests (row) {
            this.$router.push({name: 'isometric_material_request', params: {id:this.$route.params.id, id2: row.id}});
        },
        refreshIsoTable () {
            this.$refs.rt.refresh();
            this.$refs.editModal.hide();
        },
        //Working History
        onLoadWorkHistoryTable() {
            let data = http.route('history?project_id=' + this.$route.params.id + '&filters[from_table]=drawing&filters[from_id]=' + this.row.id).get();
            data.then(response => {
                if(!response.isError) {
                    this.getData.workHistoryData = response.data;
                    this.getData.workHistoryData.filter(function(value, key) {
                        if(value.project_setting == null) {
                            value.project_setting = {'info': ''};
                        }

                        if(value.team == null) {
                            value.team = {'name': ''};
                        }
                    });
                }
            });
        },
        onTaskWorkingRow (row, index) {
            this.actionTitleTask = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.administrative.task_manager.title_modal');
            this.task_model.id = null;
            this.task_model.task_title = row.project_setting.value;
            this.task_model.selectedToTeam = row.team;
            this.task_model.selectedDiscipline = this.row.discipline;
            this.task_model.exact_date = row.date;
            this.task_model.loggedUser = this.$store.state.user.user.firstname + ' ' + this.$store.state.user.user.lastname;
            this.specialInputs = [false, false, true];
            this.tableNameTranslated = Vue.i18n.translate('general.administrative.task_manager.title_modal');
            this.$refs.taskModal.show();
        },
        onAddWorkingHistory() {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.isometric_management.working_history_title');
            this.$refs.historyModal.clear();
            this.working_model.from_id = this.row.id;
            this.$refs.historyModal.show();
        },
        onEditWorkingRow(row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + Vue.i18n.translate('general.isometric_management.working_history_title');
            this.rowHistory = row;
            this.working_model.id = this.rowHistory.id;
			this.working_model.from_id = this.rowHistory.from_id;
			this.working_model.team_id = this.rowHistory.team_id;
			this.working_model.user_id = this.rowHistory.user_id;
			this.working_model.date = this.rowHistory.date;
			this.working_model.remark = this.rowHistory.remark;
			this.working_model.team = this.rowHistory.team;
			this.working_model.user = this.rowHistory.user;
			this.working_model.project_setting = this.rowHistory.project_setting;
            this.$refs.historyModal.show();
        },
        onDeleteWorkingRow(row) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.isometric_management.working_history_title');
            this.rowHistory = row;
            this.delete_message = Vue.i18n.translate('messages.delete_history');
            this.$refs.deleteModalWorking.show();
        },
        deleteActionWorking (button)  {
            if (button == 1){
                let data = http.route('history/' + this.rowHistory.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        this.refreshIsoTable();
                        this.onLoadWorkHistoryTable();
                        this.successMsg(Vue.i18n.translate('messages.deleted_history_message'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModalWorking.hide();
        },
        //Spools
        onLoadSpoolsTable() {
            let data = http.route('spool?filters[drawing_id]=' + this.row.id).get();
            data.then(response => {
                if (!response.isError) {
                    this.getData.spoolData = response.data;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddSpool () {
            this.actionTitle = Vue.i18n.translate('general.create_spool');
            this.$refs.spoolModal.clear();
            this.spool_model.drawing_id = this.row.id;
            this.spool_model.line_id = this.row.line.id;
            this.$refs.spoolModal.show();
        },
        onEditSpoolRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + Vue.i18n.translate('general.construction.spool_management.title_modal');
            this.rowSpool = row;
            this.spool_model.work_history_progress_status = this.row.work_history_progress_status;
            this.spool_model.id = row.id;
            this.spool_model.drawing_id = row.drawing_id;
            this.spool_model.line_id = row.line_id;
			this.spool_model.user_store_id = row.user_store ? row.user_store.id : null;
            this.spool_model.user_pickup_id = row.user_pickup_id;
            this.spool_model.team_pickup_id = row.team_pickup_id;
            this.spool_model.team_store_id = row.team_store_id;
            this.spool_model.ndt_test = Boolean(row.ndt_test);
            this.spool_model.heat_treatment = Boolean(row.heat_treatment);
            this.spool_model.picked_up_date = row.picked_up_date;
            this.spool_model.storage_date = row.storage_date;
            this.spool_model.spool_no = row.spool_no;
            this.spool_model.prefab_visual_test = Boolean(row.prefab_visual_test);
            this.spool_model.prefab_checked = Boolean(row.prefab_checked);
            this.spool_model.prefab_ndt_finished = Boolean(row.prefab_ndt_finished);
            this.spool_model.prefab_pwht_finished = Boolean(row.prefab_pwht_finished);
            this.spool_model.ready_erection = Boolean(row.ready_erection);
            this.spool_model.erection_visual_test = Boolean(row.erection_visual_test);
            this.spool_model.erection_checked = Boolean(row.erection_checked);
            this.spool_model.erection_ndt_finished = Boolean(row.erection_ndt_finished);
            this.spool_model.erection_pwht_finished = Boolean(row.erection_pwht_finished);
            this.spool_model.ready_pressure_test = Boolean(row.ready_pressure_test);
            this.spool_model.partial_pressure_test = Boolean(row.partial_pressure_test);
            this.spool_model.painting_finished = Boolean(row.painting_finished);
            this.spool_model.insulation_finished = Boolean(row.insulation_finished);
            this.spool_model.remark1 = row.remark1;
            this.spool_model.remark2 = row.remark2;
            this.spool_model.remark3 = row.remark3;
            this.spool_model.storage_place = row.storage_place;
            this.spool_model.x_axis = row.x_axis;
            this.spool_model.y_axis = row.y_axis;
            this.spool_model.material_picked_up = Boolean(row.material_picked_up);
            this.spool_model.painting_done = Boolean(row.painting_done);
            this.spool_model.prefab_started = Boolean(row.prefab_started);
            this.spool_model.prefab_finished = Boolean(row.prefab_finished);
            this.spool_model.spool_picked_up = Boolean(row.spool_picked_up);
            this.spool_model.erection_started = Boolean(row.erection_started);
            this.spool_model.welding_finished = Boolean(row.welding_finished);
            this.spool_model.supports_installed = Boolean(row.supports_installed);
            this.spool_model.pressure_test_finished = Boolean(row.pressure_test_finished);
            this.spool_model.reinstallment_done = Boolean(row.reinstallment_done);
            this.spool_model.delayed = row.delayed;
            this.spool_model.selectedLine = row.line;
            this.spool_model.selectedStorage = row.storage;
            this.spool_model.selectedTeamPickedUp = row.team_pickup;
            this.spool_model.selectedUserPickup = row.user_pickup;
            this.spool_model.selectedTeamStored = row.team_store;
            this.spool_model.selectedUserStore = row.user_store;
            this.$refs.spoolModal.show();
        },
        onDeleteSpoolRow(row) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.construction.spool_management.title_modal');
            this.delete_message = Vue.i18n.translate('messages.delete_spool');
            this.rowSpool = row;
            this.$refs.deleteModalSpool.show();
        },
        deleteActionSpool (button)  {
            if (button == 1) {
                let data = http.route('spool/' + this.rowSpool.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        this.onLoadSpoolsTable();
                        this.successMsg(Vue.i18n.translate('messages.deleted_spool_message'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModalSpool.hide();
        },
        clearSearches () {
            this.currentLine     = [];
            this.currentWorkType = [];

            this.selectedLine     = null;
            this.selectedWorkType = null;
        },
        updateLine(line) {
            if (line == null) {
                this.model.line_id = null;
                this.model.line.area = null;
                this.model.line.serial_no = null;
                this.model.line.line_class = null;
                this.model.line.pipe_material = null;
                this.model.line.tie_in_no = null;
                this.model.line.test_circuit_no = null;
                this.model.line.line_size = null;
                this.model.line.fluid = null;
                this.model.line.process_code = null;
                this.model.line.location_from = null;
                this.model.line.location_to = null;
                this.model.line.operating_press = null;
                this.model.line.operating_temp = null;
                this.model.line.design_press = null;
                this.model.line.design_temp = null;
                this.model.line.testing_press = null;
                this.model.line.testing_med = null;
                this.model.line.p_and_id_no = null;
                this.model.line.nde_extent_rt = null;
                this.model.line.nde_extent_pt = null;
                this.model.line.nde_extent_mt = null;
                this.model.line.nde_extent_ut = null;
                this.model.line.nde_extent_others = null;
                this.model.line.ped_category = null;
                this.model.line.ped_module_or_hazard = null;
                this.model.line.insulation_or_tracing_type = null;
                this.model.line.insulation_or_tracing_thickness = null;
                this.model.line.painting_code = null;
                this.model.line.painting_thickness = null;
                this.model.line.working_group_name = null;
                this.model.line.pwht = false;
                this.model.line.cleaning = null;
                this.model.line.visual_test = null;
                this.model.line.note_1 = null;
                this.model.line.note_2 = null;
            } else {
                this.model.line_id = line.id;
                this.model.line.line_id = line.id;
                this.model.line.area = line.area;
                this.model.line.serial_no = line.serial_no;
                this.model.line.line_class=line.line_class;
                this.model.line.pipe_material = line.pipe_material;
                this.model.line.tie_in_no = line.tie_in_no;
                this.model.line.test_circuit_no = line.test_circuit_no;
                this.model.line.line_size = line.line_size;
                this.model.line.fluid = line.fluid;
                this.model.line.process_code = line.process_code;
                this.model.line.location_from = line.location_from;
                this.model.line.location_to = line.location_to;
                this.model.line.operating_press = line.operating_press;
                this.model.line.operating_temp = line.operating_temp;
                this.model.line.design_press = line.design_press;
                this.model.line.design_temp = line.design_temp;
                this.model.line.testing_press = line.testing_press;
                this.model.line.testing_med = line.testing_med;
                this.model.line.p_and_id_no = line.p_and_id_no;
                this.model.line.nde_extent_rt = line.nde_extent_rt;
                this.model.line.nde_extent_pt = line.nde_extent_pt;
                this.model.line.nde_extent_mt = line.nde_extent_mt;
                this.model.line.nde_extent_ut = line.nde_extent_ut;
                this.model.line.nde_extent_others = line.nde_extent_others;
                this.model.line.ped_category = line.ped_category;
                this.model.line.ped_module_or_hazard = line.ped_module_or_hazard;
                this.model.line.insulation_or_tracing_type = line.insulation_or_tracing_type;
                this.model.line.insulation_or_tracing_thickness = line.insulation_or_tracing_thickness;
                this.model.line.painting_code = line.painting_code;
                this.model.line.painting_thickness = line.painting_thickness;
                this.model.line.working_group_name = line.working_group_name;
                this.model.line.cleaning = line.cleaning;
                this.model.line.pwht = Boolean(line.pwht);
                this.model.line.visual_test = line.visual_test;
                this.model.line.note_1 = line.note_1;
                this.model.line.note_2 = line.note_2;
            }
        },
        onLineSearch(search) {
            if (search == '') {
                this.currentLine = [];
                
                return false;
            }

            this.isLineLoading = true;
            this.searchLine(search, this);
        },
        searchLine: _.debounce((search, vm) => {
            http.route('line?project_id='+ vm.$route.params.id +'&get_all=1&search_select=' + search + '&filters[parent_line_id]=null').get().then(response => {
                if (response.data != false) {
                    vm.currentLine = response.data;
                }
                vm.isLineLoading = false;
            });
        }, 500),
        clearSelectedLine () {
            this.model.line_id                              = null;
            this.model.line.area                            = null;
            this.model.line.serial_no                       = null;
            this.model.line.line_class                      = null;
            this.model.line.pipe_material                   = null;
            this.model.line.tie_in_no                       = null;
            this.model.line.test_circuit_no                 = null;
            this.model.line.line_size                       = null;
            this.model.line.fluid                           = null;
            this.model.line.process_code                    = null;
            this.model.line.location_from                   = null;
            this.model.line.location_to                     = null;
            this.model.line.operating_press                 = null;
            this.model.line.operating_temp                  = null;
            this.model.line.design_press                    = null;
            this.model.line.design_temp                     = null;
            this.model.line.testing_press                   = null;
            this.model.line.testing_med                     = null;
            this.model.line.p_and_id_no                     = null;
            this.model.line.nde_extent_rt                   = null;
            this.model.line.nde_extent_pt                   = null;
            this.model.line.nde_extent_mt                   = null;
            this.model.line.nde_extent_ut                   = null;
            this.model.line.nde_extent_others               = null;
            this.model.line.ped_category                    = null;
            this.model.line.ped_module_or_hazard            = null;
            this.model.line.insulation_or_tracing_type      = null;
            this.model.line.insulation_or_tracing_thickness = null;
            this.model.line.painting_code                   = null;
            this.model.line.painting_thickness              = null;
            this.model.line.working_group_name              = null;
            this.model.line.pwht                            = false;
            this.model.line.cleaning                        = null;
            this.model.line.visual_test                     = null;
            this.model.line.note_1                          = null;
            this.model.line.note_2                          = null;
            this.selectedLine                               = null;
        },
        onWorkTypeSearch(search) {
            if (search == '') {
                this.currentWorkType = [];
                
                return false;
            }

            this.isWorkTypeLoading = true;
            this.searchWorkTypeSearch(search, this);
        },
        searchWorkTypeSearch: _.debounce((search, vm) => {
            let data = http.route('projectsetting?project_id=' + vm.$route.params.id + '&get_all=1&filters[type]=work_type&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentWorkType = response.data;
                }
                vm.isWorkTypeLoading = false;
            });
        }, 500),
        updateWorkType(work_type) {
            this.model.work_type_id = (work_type != null) ? work_type.id : null;
        },
        clearSelectedWorkType () {
            this.selectedWorkType   = null;
            this.model.work_type_id = null;
        },
        onReasonSearch(search) {
            if (search == '') {
                this.currentReason = [];
                
                return false;
            }

            this.isReasonLoading = true;
            this.searchReason(search, this);
		},
		searchReason: _.debounce((search, vm) => {
			let data = http.route("projectsetting?project_id="+vm.$route.params.id+"&filters[type]=reason_for_revision&get_all=1&search_select=" + search).get();
			data.then(response => {
                if (response.data != false) {
                    vm.currentReason = response.data;
                }
                vm.isReasonLoading = false;
			});
		}, 500),
        clearSelectedProjectSetting () {
			this.model.revision_reason_setting = null;
		},
    }
}
</script>

<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/project/isometric_management/isometric_management_revisioncontrol.vue